export default __webpack_public_path__ + "static/media/resumes.c4d2f7a5.png";